import React from "react"
import PaymentsTable from "./PaymentsTable"
import {useParams} from "react-router-dom"
import {FilterKey} from "types/filter"

const PaymentsTab = (props: {profileId?: number; userId?: number}) => {
    const params = useParams<{profileId?: string; userId?: string}>()
    const profileId = props.profileId ?? (params.profileId ? +params.profileId : undefined)
    const userId = props.userId ?? (params.userId ? +params.userId : undefined)

    return (
        <PaymentsTable
            profileId={profileId}
            userId={profileId ? undefined : userId}
            filterKey={FilterKey.StudentAccountStudentPayments}
        />
    )
}

export default PaymentsTab
